import { formAddCsrfProtection } from "./utils";

export class MpBookmark {
	constructor(element, settings) {
		this.defaults = {
			image_on: null, // Selected and unsel. image
			image_off: null,
			message: null, // Message dom element
			message_on: "", // Selected and unsel. messages
			message_on_over: null, // Message displayed on mouse over when the message_on is displayed
			message_off: "",
			counter: null, // Bookmarks counter, increased or decreased on selection
			form: null,
			hide_elements_on: [], // Array of elements to hide if the bookmark is on/off
			hide_elements_off: [],
			trigger_on: () => {}, // function to call when the bookmark change state
			trigger_off: () => {},
			click_targets: [], // if not empty the elements are used instead of the bookmark element
			error_message: "Si e' verificato un errore",
			no_action: false, // disable the bookmark
		};
		this.options = Object.assign({}, this.defaults, settings);

		this.bookmark = element;
		if (this.options.form) {
			this.form = this.options.form;
		} else {
			this.form = this.bookmark.querySelector(".bookmarks_form");
		}

		if (this.form.classList.contains("active")) {
			// On page load the active flag is on the form
			// Copy the flag to the main bookmark ( it may cause some delay displaying a bookmark status )
			this.bookmark.classList.add("active");
		}

		// event listeners and login
		const login_box =
			!!document.querySelector("#login_registration_container") &&
			!!document.querySelector("#user_nav #_user_panel_container") === false;
		if (this.options.click_targets.length === 0) {
			if (login_box) {
				window.globalLoginWindowHandler.bookmarkLogin(this.bookmark);
			}
			this.bookmark.addEventListener("click", (event) => {
				if (this.bookmark.classList.contains("no_action")) {
					return;
				}
				event.preventDefault();
				event.stopImmediatePropagation();
				this.toggle();
			});
		} else {
			for (const el of this.options.click_targets) {
				if (login_box) {
					window.globalLoginWindowHandler.bookmarkLogin(el);
				}
				el.addEventListener("click", (event) => {
					if (this.bookmark.classList.contains("no_action")) {
						return;
					}
					event.preventDefault();
					event.stopImmediatePropagation();
					this.toggle();
				});
			}
		}

		if (this.bookmark.classList.contains("active")) {
			this.setStateOn();
		} else {
			this.setStateOff();
		}
	}

	setStateOn() {
		/*
    Set the graphical state of the bookmark to active
    */

		if (this.options.click_targets.length === 0) {
			this.bookmark.classList.add("active");
		} else {
			for (const el of this.options.click_targets) {
				el.classList.add("active");
			}
		}

		if (this.options.image_on) {
			this.options.image_on.style.display = "inline";
		}

		if (this.options.image_off) {
			this.options.image_off.style.display = "none";
		}

		if (this.options.message) {
			this.options.message.innerHTML = this.options.message_on;

			if (this.options.message_on_over) {
				// Message displayed when the bookmark is active and the muose is over
				this.bookmark.addEventListener("mouseover", () => {
					this.options.message.innerHTML = this.options.message_on_over;
				});
				this.bookmark.addEventListener("mouseout", () => {
					this.options.message.innerHTML = this.options.message_on;
				});
			}
		}
		for (const el of this.options.hide_elements_on) {
			el.style.display = "none";
		}
		for (const el of this.options.hide_elements_off) {
			el.style.display = "block";
		}
	}

	setStateOff() {
		/*
    Set the graphical state of the bookmark to off
    */

		if (this.options.click_targets.length === 0) {
			this.bookmark.classList.remove("active");
		} else {
			for (const el of this.options.click_targets) {
				el.classList.remove("active");
			}
		}

		if (this.options.image_on) {
			this.options.image_on.style.display = "none";
		}

		if (this.options.image_off) {
			this.options.image_off.style.display = "inline";
		}

		if (this.options.message) {
			this.options.message.innerHTML = this.options.message_off;
			// Disable eventual messages displayed on mouse over
			if (this.options.message_on_over) {
				this.bookmark.addEventListener("mouseover", () => {
					this.options.message.innerHTML = this.options.message_off;
				});
				this.bookmark.addEventListener("mouseout", () => {
					this.options.message.innerHTML = this.options.message_off;
				});
			}
		}

		for (const el of this.options.hide_elements_on) {
			el.style.display = "block";
		}

		for (const el of this.options.hide_elements_off) {
			el.style.display = "none";
		}
	}

	isActive() {
		return this.bookmark.classList.contains("active");
	}

	sendBookmark() {
		/*
    Send the actual bookmark request by ajax.
    */

		formAddCsrfProtection(this.form).then((data) => {
			const formData = new FormData(this.form);
			fetch(this.form.getAttribute("action"), {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				method: "POST",
				body: formData,
			})
				.then((response) => {
					// ok
				})
				.catch((error) => {
					console.warn("-------- BOOKMARK ERROR");
					console.warn(this.options.error_message);
					console.warn("-----------------------");
				});
		});

		return false;
	}

	toggle() {
		/*
      Change the state of the bookmark
    */

		this.sendBookmark();

		if (!this.isActive()) {
			this.setStateOn();
			this.updateCounter();
			this.options.trigger_on();
		} else {
			this.setStateOff();
			this.updateCounter();
			this.options.trigger_off();
		}
	}

	updateCounter() {
		/*
    Update the counter
    */

		if (!this.options.counter) {
			return;
		}

		let num = this.options.counter.textContent;

		if (this.isActive()) {
			num = Number.parseInt(num) + 1;
		} else {
			if (Number.parseInt(num) > 0) {
				num = Number.parseInt(num) - 1;
			} else {
				num = 0;
			}
		}

		this.options.counter.textContent = num;
	}
}
